// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';

// utilities
import { get, find, merge, isNil } from 'lodash';
import moment from 'moment';
import cx from 'classnames';

// components
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import TextArea from '../../../../common/components/c_TextArea';
import FlatButton from '../../../../common/components/c_FlatButton';
import DateInput from '../../../../common/components/DateInput';
import ToggleButton from '../../../../common/components/c_ToggleButton';

// get validations
import {getSchema} from '../../../../models/applicantTask';

const validationObj = getSchema();

const dropDownProps = {
  style: {
    height: '45px',
    width: '100%',
    fontSize: '14.5px',
    textTransform: 'none',
    textAlign: 'left'
  },
  labelStyle: {
    padding: 0
  },
  listStyle: {
    width: '260px'
  },
  menuStyle: {
    width: '260px'
  },
  underlineStyle: {
    margin: 0,
    borderTopWidth: '1px'
  },
  iconStyle: {
    right: 0
  }
};

const taskStatusBoolean = [
  {
    value: false,
    primaryText: 'Open',
  }, {
    value: true,
    primaryText: 'Closed',
  }
];


export default class AddTaskForm extends Component {
  static propTypes = {
    submitTask: PropTypes.func,
    taskTypes: PropTypes.array,
    taskResultTypes: PropTypes.array,
    applicantId: PropTypes.number,
    selectedItem: PropTypes.object,
    category: PropTypes.string,
  }

  state = {
    taskType: get(this.props.selectedItem, 'taskTypeId'),
    taskResultType: get(this.props.selectedItem, 'taskResultId'),
    taskFollowUpDate: get(this.props.selectedItem, 'taskFollowUpDate'),
    closed: get(this.props.selectedItem, 'closed', false),
    taskNote: get(this.props.selectedItem, 'message'),
    saveDisabled: true,
    errorCount: 0
  }

  onChange(prop, event, value) {
    const newState = merge({}, this.state, {
      [prop]: !isNil(value) ? value: (event.target || {}).value,
    });

    // @TODO update this to match other validation
    newState.saveDisabled = isNil(newState.taskType);

    this.setState(newState);
  }

  onErrorChange = changeInt => {
    this.setState(merge(this.state, {errorCount: this.state.errorCount + changeInt}));
  }

  onSave() {
    const resultText = get(find(this.props.taskResultTypes, {id: this.state.taskResultType}) || {}, 'name', null);
    const taskTypeName = get(this.props.taskTypes.find((type) => type.id === this.state.taskType), 'name', null);

    this.props.submitTask({
      applicantId: this.props.applicantId,
      taskTypeId: this.state.taskType,
      taskResultId: this.state.taskResultType,
      taskResultName: resultText,
      taskFollowUpDate: this.state.taskFollowUpDate,
      closed: this.state.closed,
      category: this.props.category,
      message: this.state.taskNote,
      taskTypeName,
    });
    this.clear();
  }

  clear() {
    this.setState(merge({}, {
      taskType: null,
      taskResultType: null,
      taskNote: null
    }));
  }

  render() {
    return (
      <form className='event-form task-form'>
        <DropDownMenu className='type-dropdown task-dropdown'
                      floatingLabelText='Type of Task'
                      floatingLabelStyle={{left: 0, top: '-10px'}}
                      value={this.state.taskType}
                      onChange={this.onChange.bind(this, 'taskType')}
                      menuItems={this.props.taskTypes}
                      data-id='type of task'
                      {...dropDownProps}/>
        <DropDownMenu className='type-dropdown task-result'
                      floatingLabelText='Result'
                      floatingLabelStyle={{left: 0, top: '-10px'}}
                      value={this.state.taskResultType}
                      onChange={this.onChange.bind(this, 'taskResultType')}
                      menuItems={this.props.taskResultTypes}
                      data-id='task result'
                      {...dropDownProps}/>
        <div className='follow-up-wrapper'>
          <div className={cx('follow-up-form')} >
            <div className='label'>Follow Up Date</div>
            <DateInput
              autoOk
              data-id={'follow-up-date'}
              defaultValue={this.state.taskFollowUpDate}
              value={this.state.taskFollowUpDate}
              onChange={this.onChange.bind(this, 'taskFollowUpDate')} />
          </div>

          <ToggleButton
            className='task-status'
            data-id='Task Status'
            style={{
              width: '100%'
            }}
            defaultValue={this.state.closed}
            menuItems={taskStatusBoolean}
            onChange={this.onChange.bind(this, 'closed')}
          />
      </div>

        <TextArea
          className='other-text'
          data-id='Task Comment'
          description='Task Comment'
          style={{
            minHeight: '100px'
          }}
          defaultValue={this.state.taskNote}
          onChange={this.onChange.bind(this, 'taskNote')}
          onErrorChange={this.onErrorChange}
          maxLength={255}
          validation={validationObj.message}
        />
        <FlatButton disabled={this.state.saveDisabled || this.state.errorCount > 0}
                    onClick={::this.onSave}
                    className='save-btn'
                    data-id='save button'
                    label='Save'
                    disabledStyle={{
                      color: '#979797',
                      backgroundColor: '#fff'
                    }}
                    labelStyle={{
                      width: 'auto',
                      padding: 0
                    }}/>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/r_Events/c_AddTaskForm/index.js